import React from 'react';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import styled from 'styled-components';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { CTALink } from '@components/CTALink';

export const StyledAppCTALink = styled(CTALink)`
  margin-top: 27px;

  ${themeMediaQuery('below_sm')} {
    margin-left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const GuestMobileAppCrossSellContainer = styled(Columns)`
  max-width: 1225px;
  margin-left: auto;
  margin-right: auto;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const IPhoneWrapper = styled.div`
  width: 18rem;
  margin: auto;

  ${themeMediaQuery('below_sm')} {
    width: 18rem;
  }
`;

export const StyledIphoneImage = styled(CloudImage)`
  height: 775px;
  ${themeMediaQuery('below_sm')} {
    width: 279px;
    height: unset;
    position: relative;
    bottom: 100px;
  }
`;

export const StyledIphoneImageSVGMask = styled(CloudImage)`
  width: 500px;
  height: 775px;
`;

export const StyledMobileAppColumnContainer = styled(Columns.Column)`
  max-height: 775px;
  margin-top: auto;
  margin-bottom: auto;
  ${themeMediaQuery('sm')} {
    flex-direction: row;
  }

  ${themeMediaQuery('below_sm')} {
    max-width: 100%;
    max-height: 550px;
    padding-top: ${themeSpace(8)};
    padding-bottom: ${themeSpace(6)};
  }
`;

export const TextCTA = styled(Text)`
  margin-top: 16px;
`;

type StyledDeviceImageProps = {
  src: string;
};

export const StyledDeviceImage = styled((props) => <CloudImage {...props} />).attrs(({ src }: StyledDeviceImageProps) => ({
  src,
}))`
  width: 400px;
  height: 680px;
  position: relative;
  left: 50px;
  bottom: 650px;
`;

export const GuestMobileAppText = styled(TextPairing)`
  max-width: 550px;
  .text-pairing-title {
    max-width: 320px;
  }

  ${themeMediaQuery('sm')} {
    text-align: center;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-eyebrow,
    .text-pairing-title,
    .text-pairing-body {
      text-align: center;
    }
    .text-pairing-title {
      max-width: 330px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 410px;
    }
  }
`;

export const StyledWrapper = styled.div`
  width: 314px;
  height: 674px;
  position: relative;
  margin-left: 25px;
  margin-right: auto;
  bottom: 755px;
  border-radius: 35px;
  overflow: hidden;
  ${themeMediaQuery('below_sm')} {
    max-width: 15.25rem;
    margin-left: auto;
    margin-right: auto;
    height: unset;
    bottom: 685px;
  }
`;

export const StyledMobileClip = styled.div`
  width: 100%;
  height: 100%;
  clip-path: polygon(
    22% 0%,
    12% 0%,
    0% 0%,
    0% 0%,
    0% 0%,
    0% 0%,
    0% 0%,
    0% 100%,
    100% 100%,
    100% 0%,
    100% 0%,
    75% 0.2%,
    74% 2.9%,
    73% 3.4%,
    72% 3.8%,
    71% 3.9%,
    70% 4%,
    30% 4%,
    29% 3.9%,
    28% 3.8%,
    27% 3.4%,
    26% 2.9%,
    25% 0%
  );
`;
